import { useId } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { BreadcrumbProvider } from '../../context/BreadcrumbContext';
import { useSystemContainer } from '../../hooks/useSystemContainer';
import BreadCrumb from '../breadCrumb/BreadCrumb';
import Loading from '../loading/Loading';


export default function SystemContainerContent() {
  const { isLoading } = useSystemContainer();
  const location = useLocation();
  const mainContentId = useId();
  const loadingOverlayId = useId();
  const contentRegionId = useId();

  // Routes where the breadcrumb should not be displayed
  const hideBreadcrumbRoutes = ['/xpto'];
  const shouldHideBreadcrumb = hideBreadcrumbRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <BreadcrumbProvider>
    <div
      id={mainContentId}
      className={`flex items-start justify-center min-h-[calc(100vh-5.2rem)] lg:ml-72 relative bsds-mr-24`}
      role="main"
      aria-label="Conteúdo principal do sistema"
      aria-busy={isLoading}
    >
      {/* Content */}
      <div
        id={contentRegionId}
        className="relative z-10 w-full h-full bsds-ml-24 pt-4 md:pt-0"
        role="region"
        aria-label="Conteúdo da página"
      >
        {/* Route Identifier - Sticky at top */}
        {!shouldHideBreadcrumb && (
          <div
            className="sticky top-0 z-30 bg-background-secondary bsds-pb-4"
            role="navigation"
            aria-label="Navegação estrutural"
          >
            <BreadCrumb />
          </div>
        )}

        {/* Page Content */}
        <div className="bsds-mt-12">
          <Outlet />
        </div>
      </div>

      {/* Loading Overlay - Card with elevation above content */}
      {isLoading && (
        <div
          id={loadingOverlayId}
          className="absolute inset-0 z-50 bsds-display-flex bsds-justify-content-center bsds-align-items-center"
          role="status"
          aria-live="polite"
          aria-label="Carregando conteúdo"
          aria-busy="true"
        >
          <div className="bsds-display-flex bsds-justify-content-center bsds-align-items-center lg:-translate-x-36">
            <Loading />
          </div>
        </div>
      )}
    </div>
    </BreadcrumbProvider>
  );
}

